<template>
  <span>
    <span  v-if="!isEdit">{{labelName}}</span>
    <el-select v-else :size="size" :disabled="disabled" filterable  :value="value" @change="handleChange" :multiple="multiple">
      <el-option v-for="(item, index) in typeDatas" :key="index" :value="item[defaultProps.value]" :label="item[defaultProps.label]"></el-option>
    </el-select>
  </span>
</template>

<script>
import * as categorys from '@/api/categorys';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'select-type',
  components: {},
  props: {
    typeId: [String, Number],
    value: {
      type: [String, Number, Array],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    isGetLabel: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    },
    defaultProps: {
      type: Object,
      default() {
        return {
          label: 'name',
          value: 'dtCode'
        };
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    showValue: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
    };
  },
  destroyed() {
    // console.log('销毁')
    this.clearTypeDatas();
  },
  computed: {
    ...mapGetters({
      typeDataLists: 'typeDataLists',
      typeIds: 'typeIds'
    }),
    typeDatas() {
      const object = this.typeDataLists.length > 0 && this.typeDataLists.find(item => item.typeId === this.typeId);
      let reArray = object && object.typeDatas || [];
      reArray = reArray.filter(m => m.enable);
      return reArray;
    },
    labelName() {
      if (this.value != null && this.value.length !== 0) {
        var valuearr = this.value.toString().split('/');
        var pre = '';
        var result = '';
        for (const v of valuearr) {
          const item = this.typeDatas.find(item => item[this.defaultProps.value] === v);
          result += pre + (item && item[this.defaultProps.label] || v);
          pre = '/';
        }
        return result;
      } else {
        return '';
      }
    }
  },
  watch: {
    typeId() {
      this.getList();
    }
  },
  created() {
    this.initView();
  },
  methods: {
    ...mapActions({
      saveTypeDataLists: 'saveTypeDataLists',
      saveTypeIds: 'saveTypeIds',
      clearTypeDatas: 'clearTypeDatas'
    }),
    initView() {
      // const object = this.typeDataLists.length > 0 && this.typeDataLists.find(item => item.typeId === this.typeId)
      const type = this.typeIds.find(item => item === this.typeId);
      this.saveTypeIds(this.typeId);
      if (type) {
        return;
      }
      this.getList();
    },
    getList() {
      const listQuery = {
        page: 1,
        limit: 9999,
        TypeId: this.typeId
      };
      return categorys.getList(listQuery).then(res => {
        const obj = {
          typeId: this.typeId,
          typeDatas: res.data
        };
        this.saveTypeDataLists(obj);
      });
    },
    handleChange(val) {
      const selindex = this.typeDatas.findIndex(u => u.dtCode === val);
      // console.log(selindex, this.typeDatas, val)
      if (selindex > -1) {
        this.$emit('change', this.typeDatas[selindex]);
      }

      this.$emit('input', val);
      var result = '';
      if (this.isGetLabel) {
        var pre = '';
        if (val instanceof Array) {
          for (const v of val) {
            const item = this.typeDatas.find(item => item[this.defaultProps.value] === v);
            result += pre + (item && item[this.defaultProps.label] || v);
            pre = '/';
          }
        } else {
          const item = this.typeDatas.find(item => item[this.defaultProps.value] === val);
          result = (item && item[this.defaultProps.label] || val);
        }
        this.$emit('getLabel', result);
      }
      // else {
      //   console.log(val)
      //   const item = this.typeDatas.find(item => item[this.defaultProps.value] === val)
      //   console.log(item)
      //   result = item[this.defaultProps.label]
      //   this.$emit('getLabel', result)
      // }
    }
  }
};

</script>

<style scoped>
.el-select {
 display: block;
}
</style>
